export default __webpack_public_path__ + "static/media/DSC_0773.b8fa3a1e.JPG";